module.exports = __webpack_public_path__ + "static/img/t31.0f4c6a35.png";